<template>
    <div>
            <a-card-grid 
                :class="{ active: selectedCategory.id === category.id}"
                style="width:25%;text-align:center;cursor:pointer">
                <h4>{{category.name}}</h4>
                    <a-checkbox :checked="checked" :value="category.id" @change="selectedGroupChange"> </a-checkbox>
            </a-card-grid>

        <a-modal
                class="modalStyle"
                :visible="addCategoryVisible"
                :footer="null"
                @cancel="handleCategoryCancel"
                >

                <p style="display:flex;justify-content: center;font-weight: bolder;padding-top: 10px;">Select Categories</p>
                <div>
                    <a-form-model
                        ref="addCategoryForm"
                        :model="addCategory"
                        
                    >
                        <h4>{{selectedCategory.name}}</h4>
                        <br />
                        <a-checkbox-group v-if="checkCagetoryList" v-model="checkedList" :options="plainOptions" @change="onChange" />
                        <div v-else> <h4>No Categories found for this group, try again later</h4></div>
                        <div style="display:flex;justify-content: center;padding-bottom: 10px;">
                            <a-spin class="spinner" :spinning="loading" />
                        </div>

                        <a-form-model-item style="display: flex;justify-content: space-between;padding-top:40px;">
                            <a-button :disabled="disableAction" @click="handleSaveCategory" style="background: #418a49;color:#fff;width: 103px;border-radius:5px;">
                                Save
                            </a-button>
                            <a-button :disabled="disableAction" @click="handleCancelCategory" style="background: #ccc;color:#fff;margin-left: 50px;border-radius:5px;width: 103px;">
                                Cancel
                            </a-button>
                        </a-form-model-item>
                    </a-form-model>
                </div>
            </a-modal>
    </div>
</template>

<script>
import { mapActions } from 'vuex';
// const plainOptions = ['Apple', 'Pear', 'Orange'];
const defaultCheckedList = [];
    export default {
        name:"CategoryCard",
        props:['selectedCategory','category' ],
        data(){
            return{
                active:'active',
                checked: false,
                checkedList: defaultCheckedList,
                indeterminate: true,
                checkAll: false,
                plainOptions:[],
                addCategoryVisible: false,
                
                loading: false,
                spinloading:false,
                addCategory:{

                },
            }
        },
        computed:{
            checkCagetoryList(){
                return this.plainOptions.length > 0 ? true : false;
            },
            disableAction(){
                return this.plainOptions.length === 0 ? true : false
            }
        },
        methods:{
            ...mapActions(['','getProductCategories','addCategoryToShop']),
            handleCategoryCancel(){
                this.addCategoryVisible = false;
            },
            showSuccessAlert(message) {
                this.$notification['success']({
                    message: message,
                });
            },
            showErrorAlert(message) {
                this.$notification['error']({
                    message: message
                });
            },
            selectedGroupChange(){
                this.$emit('spinner', true);
                // console.log("Group id | ", this.selectedCategory)
                this.getProductCategories(this.selectedCategory.id).then(response => {
                    this.$emit('spinner', false);
                    if(response.status === 200){
                        this.plainOptions = response.data.data.map(item => ({
                            value:JSON.stringify(item),
                            label:item.name
                        }));
                        this.addCategoryVisible = true;
                    }else{
                        this.$emit('spinner', false);
                        console.log("Error | " , response)
                    }
                }, error => {
                    this.$emit('spinner', false);
                    console.log("Error | " , error)
                });
            },
            onChange(checkedList) {
                this.indeterminate = !!checkedList.length && checkedList.length < this.plainOptions.length;
                this.checkAll = checkedList.length === this.plainOptions.length;
            },
            handleSaveCategory(){   
                let objectData = this.checkedList.map(data => (JSON.parse(data)))
                objectData.forEach(data => {
                    let request_data  = {};

                    if(data.isRestricted){
                        request_data['productCategoryId'] = data.id
                        request_data['status'] = 2
                    }else{
                        request_data['productCategoryId'] = data.id
                        request_data['status'] = 1
                    }
                    this.addCategoryToShop(request_data).then(() => {}, error => {
                        console.log("Error | " , error)
                    });
                })

                this.showSuccessAlert("Categories has been added to the your catalog successfully")
                           
                if(this.category.id === this.selectedCategory.id){
                    this.checked = true;
                }
                this.addCategoryVisible = false;
            },
            handleCancelCategory(){
                this.checked = false;
                this.addCategoryVisible = false;
            },
           
        },
        created(){
            // console.log("this.selectedCategory | ", this.selectedCategory.id)
            // if(!(this.selectedCategory.id === null || this.selectedCategory.id === undefined)){
            //     this.getCategories();
            // }
        }
    }
</script>

<style scoped>
.active{
    background: #418a49; 
}

.modalStyle >>> .ant-modal-header {
    border-bottom: none;
}

.modalStyle >>> .ant-modal-footer {
    border-top: none;
}
.modalStyle{
    display: flex;
    justify-content: center;
}
.active > h4{
    color:#fff;
}
</style>